// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__141uo","buttons":"styles_buttons__2cw5g"};